import Text from 'components/Text/Text';
import React, { useContext, useEffect } from 'react';
import {
	ICreateCredentialsContext,
	CreateCredentialsContext,
} from '../../createCredentialsState/createCredentialsContext';
import {
	IWithAdditionalValidationContext,
	WithAdditionalValidationContext,
} from 'components/WithAdditionalValidation/withAdditionalValidationContext';
import { CredentialName } from './components/CredentialName';
import { ApiKey } from './components/ApiKey';
import { ApiSecret } from './components/ApiSecret';
import { BtnBlock } from './components/BtnBlock';
import { Form } from 'antd';
import { preventDefaultForEnterKey } from 'utils/helpers';
import style from './CreationForm.module.scss';

export const CreationForm: React.FC = () => {
	const { setMainFormValidationFail, additionalValidationErrors } = useContext<IWithAdditionalValidationContext>(
		WithAdditionalValidationContext,
	);

	const {
		changeTypeOfModalWindow,
		setDataForSubmit,
		changeCredentialName,
		changeApiKey,
		changeApiSecret,
		credentialName,
		apiKey,
		apiSecret,
	} = useContext<ICreateCredentialsContext>(CreateCredentialsContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({ credentialName, apiKey, apiSecret });
	}, [credentialName, apiKey, apiSecret]);

	const submit = async () => {
		setMainFormValidationFail(false);
		setDataForSubmit({
			type: 'VivaWallet',
			name: credentialName,
			apiKey,
			apiSecret,
		});
		additionalValidationErrors.length
			? setMainFormValidationFail(true)
			: changeTypeOfModalWindow('toConfirmSubmit');
	};

	const handleFormValidationFail = () => {
		setMainFormValidationFail(true);
	};

	return (
		<div className={style.container} data-test="CreationForm">
			<div className={style.formWrapper}>
				<Form
					form={form}
					name="basic"
					onFinish={submit}
					onKeyPress={preventDefaultForEnterKey}
					onFinishFailed={handleFormValidationFail}
					layout="vertical">
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="mainInfoHeading"
							theme="secondary"
							size="l"
							weight="bold"
							display="inline"
						/>
						<CredentialName onChange={changeCredentialName} />
						<div className={style.row}>
							<ApiKey onChange={changeApiKey} />
							<ApiSecret onChange={changeApiSecret} />
						</div>
					</div>
					<BtnBlock />
				</Form>
			</div>
		</div>
	);
};
